export class MdvipUserCookie {
  Username: string;
  InteropID: string;
  FirstName: string;
  LastName: string;
  Email: string;
  Auth: string;
  Groups: any[];
}
